var jsMaterialsTrigger = '.materials[data-template="compact-vertical-icons"] .js-materials-trigger', //Селектор кнопки показать/скрыть материалы
		jsMaterialsList = '.materials[data-template="compact-vertical-icons"] .js-materials-list', //Селектор списка материалов
		$jsMaterialsTrigger = $(jsMaterialsTrigger), //jquery object кнопки показать/скрыть материалы
		$jsMaterialsList = $(jsMaterialsList); //jquery object списка материалов

//Функция показать/скрыть материалы
function toggleMaterials() {
	var $this = $(this);
	if ($this.hasClass('is-expand')) {
		$.Velocity($jsMaterialsList, 'transition.slideUpOut', 200)
			.then(function () {
				$this
					.removeClass('is-expand')
					.siblings('.js-materials-list')
					.removeClass('is-expand');
			})
			.catch(console.error);
	} else {
		$this
			.addClass('is-expand')
			.siblings('.js-materials-list')
			.addClass('is-expand')
			.velocity('transition.slideDownIn', 200);
	}
}

//Обработчики событий
$jsMaterialsTrigger.on('click', function (event) {
	event.preventDefault();
	toggleMaterials.apply(this);
});

$(document).on('click', function (event) {
	if (!$(event.target).closest(jsMaterialsTrigger).length) {
		$.Velocity($jsMaterialsList, 'transition.slideUpOut', 200)
				.then(function () {
					$jsMaterialsTrigger
						.removeClass('is-expand')
						.siblings('.js-materials-list')
						.removeClass('is-expand');
				})
				.catch(console.error);
	}
});



/** WEBPACK FOOTER **
 ** ./frontend/components/materials/compact-vertical-icons/compact-vertical-icons.js
 **/